import { RumInitConfiguration, datadogRum } from '@datadog/browser-rum';

export function setDatadogUser(user: { id: string; email: string }) {
  datadogRum.setUser({
    id: user.id,
    email: user.email,
  });
}

const apiBaseUrl = process.env.REACT_APP_API_URL;
const crystalApiBaseUrl = process.env.CRYSTAL_API_URL;

const initObject: RumInitConfiguration = {
  applicationId: process.env.DATADOG_APPLICATION_ID || '',
  clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: process.env.DATADOG_SERVICE || '',
  env: process.env.DATADOG_ENV || '',
  version: process.env.commit || 'unavailable',
  sessionSampleRate: 0,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  enableExperimentalFeatures: ['feature_flags'],
  allowedTracingUrls: apiBaseUrl ? [(url: string) => url.startsWith(apiBaseUrl)] : [],
  allowedGraphQlUrls: crystalApiBaseUrl ? [(url: string) => url.startsWith(crystalApiBaseUrl)] : [],
};

datadogRum.init(initObject);
